import {
  DraftBendingTextConfiguration,
  DraftConfiguration,
  DraftConfigurationWithText,
  DraftConfigurationWithTextOrSpecialText,
  DraftDesignConfiguration,
  DraftPlaceholderTextConfiguration,
  DraftSpecialTextConfiguration,
  DraftTextConfiguration,
  DraftTextOrPlaceholderTextConfiguration,
} from '@/types';

export const isDraftDesignConfiguration = (
  configuration: DraftConfiguration
): configuration is DraftDesignConfiguration => configuration?.type === 'design';

export const isDraftTextConfiguration = (
  configuration: DraftConfiguration
): configuration is DraftTextConfiguration => configuration?.type === 'text';

export const isDraftPlaceholderTextConfiguration = (
  configuration: DraftConfiguration
): configuration is DraftPlaceholderTextConfiguration => configuration?.type === 'placeholderText';

export const isDraftBendingTextConfiguration = (
  configuration: DraftConfiguration
): configuration is DraftBendingTextConfiguration => configuration?.type === 'bendingText';

export const isDraftSpecialTextConfiguration = (
  configuration: DraftConfiguration
): configuration is DraftSpecialTextConfiguration => configuration?.type === 'specialText';

export const isDraftConfigurationWithTextOrSpecialText = (
  configuration: DraftConfiguration
): configuration is DraftConfigurationWithTextOrSpecialText =>
  configuration && !isDraftDesignConfiguration(configuration);

export const isDraftConfigurationWithText = (
  configuration: DraftConfiguration
): configuration is DraftConfigurationWithText =>
  isDraftTextOrPlaceHolderTextConfiguration(configuration) ||
  isDraftBendingTextConfiguration(configuration);

export const isDraftTextOrPlaceHolderTextConfiguration = (
  configuration: DraftConfiguration
): configuration is DraftTextOrPlaceholderTextConfiguration =>
  isDraftTextConfiguration(configuration) || isDraftPlaceholderTextConfiguration(configuration);
